import { render, staticRenderFns } from "./RankBadge.vue?vue&type=template&id=a9699e6a&"
import script from "./RankBadge.vue?vue&type=script&lang=js&"
export * from "./RankBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports